<div class="page-footer row m-0 footer">
    <div class="col p-0 d-flex align-items-center justify-content-center">
        Copyright © {{currentYear | date:'yyyy'}} ASC. All Rights Reserved
    </div>
</div>